'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getError = exports.Select = exports.DatePicker = exports.Input = exports.Help = exports.FormGroup = exports.Form = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _first = require('lodash/first');

var _first2 = _interopRequireDefault(_first);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a submit handler that will invoke the
 * specified function after preventing defaults.
 */
var createSubmitHandler = function createSubmitHandler(onSubmit) {
  return function (e) {
    e.preventDefault();
    if (onSubmit) onSubmit(e);
  };
};

/**
 * Help block.
 */
var Help = function Help(_ref) {
  var help = _ref.help,
      error = _ref.error;
  return error || help ? _react2.default.createElement(
    'span',
    { className: (0, _classnames2.default)('help', error && 'is-danger') },
    error || help
  ) : null;
};

Help.propTypes = {
  help: _propTypes2.default.node,
  error: _propTypes2.default.node
};

/**
 * Form.
 */
var Form = function Form(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      onSubmit = _ref2.onSubmit,
      opts = (0, _objectWithoutProperties3.default)(_ref2, ['children', 'className', 'onSubmit']);
  return _react2.default.createElement(
    'form',
    (0, _extends3.default)({
      className: (0, _classnames2.default)('Form', className)
    }, opts, {
      onSubmit: createSubmitHandler(onSubmit)
    }),
    children
  );
};

Form.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  onSubmit: _propTypes2.default.func
};

exports.Form = Form = (0, _mobxReact.observer)(Form);

/**
 * Form group, wraps form components with proper spacing.
 */
var FormGroup = function FormGroup(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      label = _ref3.label;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('FormGroup', className) },
    label && _react2.default.createElement(
      'label',
      { className: 'label' },
      label
    ),
    children
  );
};

FormGroup.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  label: _propTypes2.default.node
};

/**
 * Helper to grab an error from a model.
 */
var getError = function getError(model, field) {
  if (!model.validation || !model.validation.errors) return undefined;
  var errors = model.validation.errors[field];
  if (errors) {
    return (0, _first2.default)(errors);
  }

  return undefined;
};

/**
 * Input field component.
 */
var Input = function Input(_ref4) {
  var model = _ref4.model,
      field = _ref4.field,
      label = _ref4.label,
      help = _ref4.help,
      className = _ref4.className,
      props = (0, _objectWithoutProperties3.default)(_ref4, ['model', 'field', 'label', 'help', 'className']);

  var error = getError(model, field);
  return _react2.default.createElement(
    FormGroup,
    { className: 'Input', label: label },
    _react2.default.createElement(
      'div',
      { className: 'control' },
      _react2.default.createElement('input', (0, _extends3.default)({
        type: 'text',
        className: (0, _classnames2.default)('input', error && 'is-danger', className),
        value: model[field] === undefined ? '' : model[field],
        onChange: (0, _mobx.action)(function (e) {
          model[field] = e.target.value;
        }),
        disabled: model.disabled
      }, props)),
      _react2.default.createElement(Help, { error: error, help: help })
    )
  );
};

Input.propTypes = {
  model: _propTypes2.default.object,
  field: _propTypes2.default.string,
  label: _propTypes2.default.node,
  help: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.Input = Input = (0, _mobxReact.observer)(Input);

/**
 * Select field component.
 */
var Select = function Select(_ref5) {
  var model = _ref5.model,
      field = _ref5.field,
      label = _ref5.label,
      help = _ref5.help,
      className = _ref5.className,
      props = (0, _objectWithoutProperties3.default)(_ref5, ['model', 'field', 'label', 'help', 'className']);

  var error = getError(model, field);
  return _react2.default.createElement(
    FormGroup,
    { className: 'Select', label: label },
    _react2.default.createElement(
      'div',
      { className: 'control' },
      _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('select', error && 'is-danger', className) },
        _react2.default.createElement('select', (0, _extends3.default)({
          value: model[field] === undefined ? '' : model[field],
          onChange: (0, _mobx.action)(function (e) {
            model[field] = e.target.value;
          }),
          disabled: model.disabled
        }, props))
      ),
      _react2.default.createElement(Help, { error: error, help: help })
    )
  );
};

Select.propTypes = {
  model: _propTypes2.default.object,
  field: _propTypes2.default.string,
  label: _propTypes2.default.node,
  help: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.Select = Select = (0, _mobxReact.observer)(Select);

/**
 * Date picker component.
 */
var DatePicker = function DatePicker(_ref6) {
  var model = _ref6.model,
      field = _ref6.field,
      label = _ref6.label,
      help = _ref6.help,
      className = _ref6.className,
      props = (0, _objectWithoutProperties3.default)(_ref6, ['model', 'field', 'label', 'help', 'className']);

  var error = getError(model, field);
  return _react2.default.createElement(
    FormGroup,
    { className: 'Input', label: label },
    _react2.default.createElement(
      'div',
      { className: 'control' },
      _react2.default.createElement(_reactDatepicker2.default, (0, _extends3.default)({
        className: (0, _classnames2.default)('input', error && 'is-danger', className),
        selected: model[field] === undefined ? null : model[field],
        onChange: (0, _mobx.action)(function (date) {
          model[field] = date;
        }),
        disabled: model.disabled
      }, props)),
      _react2.default.createElement(Help, { error: error, help: help })
    )
  );
};

DatePicker.propTypes = {
  model: _propTypes2.default.object,
  field: _propTypes2.default.string,
  label: _propTypes2.default.node,
  help: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.DatePicker = DatePicker = (0, _mobxReact.observer)(DatePicker);

exports.Form = Form;
exports.FormGroup = FormGroup;
exports.Help = Help;
exports.Input = Input;
exports.DatePicker = DatePicker;
exports.Select = Select;
exports.getError = getError;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Form/index.js
// module id = 87
// module chunks = 0